import { berechnung } from './client'

import { createClient } from '@hey-api/client-fetch'
import { useTextStore } from './stores/texts'

export const gavClient = createClient({
  baseUrl: import.meta.env.VITE_GAV_API_HOST
})

export const client = createClient({
  baseUrl: import.meta.env.VITE_API_HOST
})

export const modelClient = createClient({
  baseUrl: import.meta.env.VITE_MODEL_API_HOST
})

export function setupClients() {
  const textStore = useTextStore()

  client.interceptors.request.use((request) => {
    request.headers.set('Accept-Language', textStore.language)
    return request
  })
}

export async function submitLohnrechner(store, resultStore) {
  if (store.branche == null) {
    resultStore.state = 'stale'
    return
  }
  resultStore.state = 'loading'
  resultStore.errors = {}

  let request = {
    beruf: store.beruf,
    branche: store.branche,
    age: store.age,
    experience: Math.min(store.experience, store.age - 18),
    position: store.stellung,
    education: store.ausbildung,
    plz: store.onrp,
    stunden: store.stunden,
    first_name: store.contact.first_name,
    last_name: store.contact.last_name,
    email: store.contact.email
  }

  let response = await berechnung({ body: request, client: client })

  if (response.error) {
    resultStore.state = 'error'
    Object.keys(response.error).forEach((key) => {
      resultStore.errors[key] = response.error[key][0]
    })
    return
  }
  let data = response.data

  resultStore.result['p25'] = data.quantiles[0]
  resultStore.result['p50'] = data.quantiles[1]
  resultStore.result['p75'] = data.quantiles[2]
  resultStore.result.is_national = data.is_national

  Object.assign(resultStore.request, data.request)
  resultStore.state = 'done'

  return resultStore.state
}
